import React from 'react';

import { TextField, TextAreaField, MCButton } from 'src/components/basic';
import { MediaDropBox } from 'src/components/complex';
import BaseComponent from 'src/components/BaseComponent';

import { lang, remCss } from 'src/helpers';


export default class CreateTimeline extends BaseComponent {
  componentDidMount() {
    this.props.model.subscribe(this.subscription);
    this.props.model.resetAddTimeline(this.props.item, this.props.journey);
  }

  componentWillUnmount() {
    this.props.model.unsubscribe(this.subscription);
  }

  submit = (e) => {
    e.preventDefault();
    const { hide, item } = this.props;
    if (item?.id) {
      this.props.model.update(item.id, ( error, data, success) => {
        if (success) hide();
      });
    } else {
      this.props.model.create((error, data, success) => {
        if (success) hide();
      });
    }
  };

  render() {
    const { closeBtn, model, hide, item } = this.props;
    const apiId = item?.id  ? 'update' : 'create';
    const createState = model.getApiState(apiId);
    const { invalid, loading } = createState;

    return (
      <div className='mc-popup-contain' style={{ width: remCss(600) }}>
        <div className='mc-modal-header'>
          <div className='mc-popup-title'>{lang.t(item?.id ? 'Edit Entry' : 'New Entry')}</div>
          {closeBtn}
        </div>
        <form className='mc-modal-body mc-flex-15-col' onSubmit={this.submit}>
          <TextField
            template={5}
            name={'title'}
            label={'Title'}
            placeholder={'enter title'}
            value={model.listInput('title')}
            onChange={model.listHandleChange}
            onBlur={(key, value) => {
              model.handleBlur(key, value, apiId);
            }}
            invalid={invalid}
          />
          <TextAreaField
            rows={3}
            template={5}
            name={'description'}
            label={'Description'}
            placeholder={'write here'}
            value={model.listInput('description')}
            onChange={model.listHandleChange}
            onBlur={(key, value) => {
              model.handleBlur(key, value, apiId);
            }}
            invalid={invalid}
          />
          <div className={'mc-flex-col'}>
            <div className={'mc-value-420'}>{lang.t('Photos / Files')}</div>
            <MediaDropBox
              template={2}
              name={'files'}
              labelIcon='Add File'
              multi={true}
              onChange={(n, v) => {
                model.resetApiState(apiId);
                model.listHandleFiles(n, v);
              }}
              onChangeMedia={(file, index) => {
                model.resetApiState(apiId);
                model.listHandleFiles('media',
                  (model.listInput('media') || []).filter((item, i) => i !== index));
              }}
              value={model.listInput('files') !== '' ? model.listInput('files') : []}
              media={model.listInput('media') || []}
              invalid={invalid}
            />
          </div>
        </form>
        <div className='mc-modal-footer mc-flex'>
          <div className={'mc-grow'} />
          <MCButton
            medium
            primary
            radius
            light
            disabled={loading}
            type={'button'}
            onClick={hide}
            label={'Cancel'}
          />
          <MCButton
            medium
            primary
            radius
            dark
            disabled={loading}
            type={'submit'}
            onClick={this.submit}
            label={loading ? lang.t(item?.id ? 'Editing' : 'Adding') + '...' : lang.t(item?.id ? 'Edit' : 'Add entry')}
          />
        </div>
      </div>
    );
  }
}
